import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
function SmallHelpText(props) {
  return /*#__PURE__*/_jsx(Small, {
    use: "help",
    weight: "medium",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "text",
      message: props.textLangPath
    })
  });
}
SmallHelpText.propTypes = {
  textLangPath: PropTypes.string.isRequired
};
export default SmallHelpText;